import script from "./BasePlan.vue?vue&type=script&lang=js"
export * from "./BasePlan.vue?vue&type=script&lang=js"

const __exports__ = script;

export default __exports__